import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { RestaurantGroupStore } from '#modules/restaurant-groups/views/restaurant-groups-view/stores/restaurant-group.store';
import { SocialNetworksCommunityInsightsContext } from '#modules/statistics-social-networks/context/social-networks-community-insights.context';
import { SocialNetworksPostsInsightsV2Context } from '#modules/statistics-social-networks/context/social-networks-post-insights-v2.context';
import { AbstractDownloadCsvInsights } from '#modules/statistics/components/download-insights-modal/services/download-csv-insights.abstract.service';
import { DownloadCsvInsightsService } from '#modules/statistics/components/download-insights-modal/services/download-csv-insights.service';
import { DOWNLOAD_CSV_INSIGHTS_PROVIDERS } from '#modules/statistics/components/download-insights-modal/utils/providers/download-csv-insights.provider';
import { StatisticsFiltersContext } from '#modules/statistics/components/filters/filters.context';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';
import { DOWNLOAD_INSIGHTS_SUMMARY_PROVIDERS } from '#modules/statistics/utils/providers/csv-inisights-summary/download-insights-summary';

export function provideStatisticsScope(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: AbstractDownloadCsvInsights, useClass: DownloadCsvInsightsService },
        StatisticsStore,
        StatisticsFiltersContext,
        RestaurantGroupStore,
        SocialNetworksCommunityInsightsContext,
        SocialNetworksPostsInsightsV2Context,
        ...DOWNLOAD_INSIGHTS_SUMMARY_PROVIDERS,
        ...DOWNLOAD_CSV_INSIGHTS_PROVIDERS,
    ]);
}
